import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';
import './GroupRules.less';

export default class GroupRules extends OfficialPage {
  state = {}

  constructor(props) {
    super(props);
    document.title = '拼团须知';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {}

  componentDidMount() {}

  componentDidMount() {}

  componentDidHide() {}

  componentWillUnmount() {}

  onPullDownRefresh = () => {}
  onReachBottom = () => {}

  render() {
    return (
      <div className="official-page group-rules">
        <TopNav title="拼团须知" />
        <div className="wrap">
        <div className="title">参与条件</div>
        <div className="content">
          1.
          参与用户（包括开团用户和参团用户）需在小程序内允许授权，并绑定有效手机号码，才能参加拼团活动。（若进入时未允许授权，请点击右上角，选择关于，在设置里打开授权。）
        </div>
        <div className="title">玩法介绍</div>
        <div className="content">
          1. 活动期间，用户可以在拼团商品详情下单发起拼团。
        </div>
        <div className="content">
          2.
          用户只有付款成功，才算成功开团或者成功参团，创建订单未付款不算有效参与拼团玩法。
        </div>
        <div className="content">
          3.
          拼团列表中显示N人团，为N人成团（例：3人团含义为3人成团，先付款的成员先加入团，人数满3人即为拼团成功）。每位用户在同一个团内只占1个拼团人数。
        </div>
        <div className="content">
          4.
          用户在规定时间内达到拼团人数，则拼团成功，商家分别发货；如果未能在规定时间内达到拼团人数，则拼团失败，系统自动触发退款。
        </div>
        <div className="content">
          5. 为保证拼团成功，开团时请根据实际情况选择合适的拼团人数。
        </div>
        <div className="title">注意事项</div>
        <div className="content">
          1.
          用户需在开团后规定的拼团时限内完成拼团，如果在拼团时限内商品拼团活动结束，拼团仍未成功，则默认用户拼团失败。
        </div>
        <div className="content">
          2.
          商品开团期间，用户进行中的团（包括自行开团与参团）数量不得超过商家限制的数量（拼团成功与拼团失败的团不计入进行中的团），在每个团中购买的商品数量不得超过商家限制的数量。
        </div>
        <div className="content">
          3. 用户付款成功后，在拼团进行时不可申请退款。
        </div>
        {/*  <view class="content">4.	拼团活动与优惠券和会员卡不冲突，当满足优惠条件后，系统会在拼团价的基础上计算优惠后的价格。</view>  */}
      </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/group-rules/GroupRules.jsx